import { useCurrentTeam } from '@/providers/TeamProvider';
import { Link } from 'react-router-dom';
import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';

export const TeamElement = () => {
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();

  return (
    <div className="card mb-4" id="basic-info">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">チーム基本設定</h5>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {isAdmin && (
            <Link
              to={`/w/${_w_!.identifier}/setting/teams/${_t_!.id}/edit`}
              className="btn btn-icon-only btn-outline-success"
            >
              <i className="fas fa-edit text-success text-sm"></i>
            </Link>
          )}
        </div>
      </div>
      <div className="card-body pt-0 row">
        <div className="form-group">
          <label>チーム名</label>
          <p className="form-text text-muted text-sm mb-0">{_t_!.name}</p>
        </div>
        <div className="form-group">
          <label>メモ</label>
          <p className="form-text text-muted text-sm mb-0">
            <SimpleTextFormat content={_t_!.description || ''} />
          </p>
        </div>
        <div className="row">
          <div className="col-12 col-md-4">
            <div className="form-group">
              <label>プロジェクト（売上）に表示</label>
              <p className="form-text mb-0">
                {_t_!.sales_order_menu_listed ? (
                  <span className="badge badge-sm badge-success">表示する</span>
                ) : (
                  <span className="badge badge-sm badge-danger">表示しない</span>
                )}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group">
              <label>プロジェクト（費用）に表示</label>
              <p className="form-text mb-0">
                {_t_!.purchase_order_menu_listed ? (
                  <span className="badge badge-sm badge-success">表示する</span>
                ) : (
                  <span className="badge badge-sm badge-danger">表示しない</span>
                )}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group">
              <label>代理店を有効化</label>
              <p className="form-text mb-0">
                {_t_!.agency_enabled ? (
                  <span className="badge badge-sm badge-success">有効</span>
                ) : (
                  <span className="badge badge-sm badge-danger">無効</span>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
